import React from 'react';

/**
 * EditingBanner — shown at the bottom of the chat when the user is editing
 * an existing message. Displays the original content and a cancel button.
 */
const EditingBanner = ({ content, onCancel }) => (
  <div className="flex items-center gap-2 px-4 py-2 bg-blue-50 border-t border-blue-200">
    <svg className="w-4 h-4 text-blue-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
    </svg>
    <p className="text-xs text-blue-700 flex-1 truncate">
      Editing: <span className="font-medium">{content}</span>
    </p>
    <button onClick={onCancel} className="text-blue-500 hover:text-blue-700 p-1">
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>
);

export default EditingBanner;
